import {
  getPartnerAccessDeniedPath,
  PartnerAccessDeniedCode,
  xboxOnboardSiteLocationPrefix,
} from "../constants";
import { XboxOnboardApplicationStatus } from "../server/crm/api/models/xboxOnboardModels";

export const getPartnerDashboardEntryRedirect = (
  status: XboxOnboardApplicationStatus | undefined,
  shouldStartOnboarding: boolean,
  isPartnerCenterAccessDenied = false,
  accessDeniedCode?: PartnerAccessDeniedCode
): string | undefined => {
  if (isPartnerCenterAccessDenied || accessDeniedCode !== undefined) {
    return getPartnerAccessDeniedPath(accessDeniedCode);
  }

  if (
    status !== XboxOnboardApplicationStatus.Initial &&
    status !== XboxOnboardApplicationStatus.FormReady
  ) {
    return undefined;
  }

  return `${xboxOnboardSiteLocationPrefix}/${shouldStartOnboarding ? "new" : "signup"}`;
};
